import { render, staticRenderFns } from "./FormSwitch.vue?vue&type=template&id=645d6f78&scoped=true&"
import script from "./FormSwitch.vue?vue&type=script&lang=js&"
export * from "./FormSwitch.vue?vue&type=script&lang=js&"
import style0 from "./FormSwitch.vue?vue&type=style&index=0&id=645d6f78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645d6f78",
  null
  
)

export default component.exports